import React from "react";
import { Box, Typography, Card, Divider } from "@mui/material";
import Draggable from "react-draggable";

const DirectionsInfoBox = ({ directions, nodeRef, showSearch }) => {
  return (
    <Draggable nodeRef={nodeRef}>
      <Box
        sx={{
          position: "absolute",
          top: showSearch ? 120 : 60,
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 2,
          width: 300,
          cursor: "move",
        }}
        ref={nodeRef}
      >
        <Card sx={{ p: 1, backgroundColor: "#ffffff !important" }}>
          <Typography variant="subtitle2">{directions.info.from}</Typography>
          <Typography variant="subtitle2">↓</Typography>
          <Typography variant="subtitle2">{directions.info.to}</Typography>
          <Divider sx={{ my: 1 }} />
          <Typography variant="body2">🛣️ {directions.info.distance}</Typography>
          <Typography variant="body2">⏱️ {directions.info.duration}</Typography>
        </Card>
      </Box>
    </Draggable>
  );
};

export default DirectionsInfoBox;
